// File: frontend/src/components/Leads/leadFormat.js
// Shared formatting helpers for the Leads table and mobile cards.

// lead_score está en escala 0-10. La escala y las bandas viven en
// frontend/src/utils/leadScore.js — no dupliques umbrales aquí.
export { getScoreColor, formatLeadScore } from '../../utils/leadScore';

export const formatDate = (dateString) =>
  dateString ? new Date(dateString).toLocaleDateString('pt-BR') : '-';
